import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, XIcon } from 'lucide-react';
import { Button } from '../../ui/Button';
import { UniversityMark } from '../UniversityMark';
import { COMPARE_LIMIT, useDiscover } from '../../../contexts/DiscoverContext';

/**
 * Design A's comparison tray: an in-flow panel that closes the page, matching
 * the composition's calmer, editorial rhythm. It reads and writes the same
 * comparison state as Design B's floating bar.
 */
export function CompareBarA() {
  const {
    compared,
    removeCompare,
    clearCompare,
    setCompareOpen
  } = useDiscover();
  const [collapsed, setCollapsed] = useState(false);
  if (compared.length === 0) return null;
  return <section aria-label="Universities selected for comparison" className="rounded-card border border-line bg-surface p-4 shadow-[0_10px_30px_rgba(15,23,42,0.06)] sm:p-5" data-id="element-1202" data-mp="fvo8j62r6gsq">
      <div className="flex flex-wrap items-center gap-3" data-id="element-1203" data-mp="1rb4f3vkodsdl">
        <h2 className="text-body font-semibold text-ink" data-id="element-1204" data-mp="1r9jlq9a3kfhb">
          Compare {compared.length}{' '}
          {compared.length === 1 ? 'university' : 'universities'}
        </h2>
        <button type="button" onClick={clearCompare} className="text-body-sm text-ink-muted underline-offset-4 hover:text-ink hover:underline" data-id="element-1205" data-mp="1gby09qsvmaal">
          Clear
        </button>
        <div className="ml-auto flex items-center gap-2" data-id="element-1206" data-mp="16c71ve173b58">
          <Button variant="primary" onClick={() => setCompareOpen(true)} disabled={compared.length < 2} data-id="element-1207" data-mp="11e5l4zr8rnwx">
            Compare now
          </Button>
          <button type="button" onClick={() => setCollapsed(current => !current)} aria-expanded={!collapsed} aria-label={collapsed ? 'Show selected universities' : 'Hide selected universities'} className="flex min-h-touch min-w-touch items-center justify-center rounded-lg border border-line text-ink-muted transition-colors duration-150 ease-out hover:text-ink" data-id="element-1208" data-mp="sl27orgljb2a">
            {collapsed ? <ChevronUpIcon aria-hidden className="h-5 w-5" data-id="element-1209" data-mp="42iemzgl1iec" /> : <ChevronDownIcon aria-hidden className="h-5 w-5" data-id="element-1210" data-mp="913c4r4g9nz3" />}
          </button>
        </div>
      </div>

      {!collapsed && <ul className="mt-4 flex flex-wrap gap-2" data-id="element-1211" data-mp="3v6grw1t5lekp">
          {compared.map(university => <li key={university.id} className="flex items-center gap-2.5 rounded-lg border border-line bg-canvas py-1.5 pl-2 pr-1.5" data-id="element-1212" data-mp="mr6w1bfux5ld">
              <UniversityMark university={university} size="sm" data-id="element-1213" data-mp="rs4elp4s41ne" />
              <span className="min-w-0" data-id="element-1214" data-mp="dxtuxm7n2xo7">
                <span className="block truncate text-body-sm font-medium text-ink" data-id="element-1215" data-mp="dwset3brnkzm">
                  {university.name}
                </span>
                <span className="block text-caption text-ink-muted" data-id="element-1216" data-mp="15oq70klvkyaf">
                  {university.city}, {university.country}
                </span>
              </span>
              <button type="button" onClick={() => removeCompare(university.id)} aria-label={`Remove ${university.name} from the comparison`} className="flex min-h-touch min-w-touch items-center justify-center rounded-lg text-ink-subtle transition-colors duration-150 ease-out hover:text-ink" data-id="element-1217" data-mp="2v6n4kpyxqami">
                <XIcon aria-hidden className="h-4 w-4" data-id="element-1218" data-mp="2zzpwkto2dc0l" />
              </button>
            </li>)}
        </ul>}

      {compared.length < 2 && !collapsed && <p className="mt-3 text-caption text-ink-subtle" data-id="element-1219" data-mp="27airfbu3to6d">
          Add one more institution to compare them side by side. You can compare up to{' '}
          {COMPARE_LIMIT}.
        </p>}
    </section>;
}